import styled from '@emotion/styled'
import ArrowDownLineIcon from '@rsuite/icons/ArrowDownLine'
import ArrowUpLineIcon from '@rsuite/icons/ArrowUpLine'
import theme from '../../../styles/theme'
import { css } from '@emotion/react'

export const dropdownContainer = css`
  display: inline-block;
  position: relative;
  display: inline-block;
  margin: 1px;
  //@container MiddleAlignedContainer (max-width: 500px) {
  //   background-color: #4400ff;
  //}
  .inactive {
    opacity: 0.6;
    cursor: not-allowed;

    &:hover {
      background: inherit;
      border-color: #d0d5dd;
    }
  }
`

export const dropdownMenu = css`
  position: absolute;
  top: 100%;
  right: 0;
  min-width: 200px;
  background: white;
  border-radius: 0.6rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 0.4rem 0;
  padding-top: 0.7rem;
  margin-top: 0.7rem;
  z-index: 1000;
  display: none;
  flex-direction: column;
  &.open {
    display: flex;
  }
`

export const dropdownItem = css`
  font-family: Inter, sans-serif;
  color: #344054;
  padding: 0.5rem 1rem;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background-color: ${`${theme.colors.secondLight}A0`};
    color: ${theme.colors.secondDarkest};
    //removing default <a> tag css styling
    text-decoration: none;
  }

  &.inactive {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none; // This will completely disable hover effects
    color: #344054; // Keep the same color even when inactive
  }

  &.active {
    background-color: ${`${theme.colors.second}40`};

    &:hover {
      background-color: ${`${theme.colors.second}40`};
      color: #344054;
    }
  }
`

export const button = css`
  // ...existing styles...
  .arrow {
    margin-left: 0.5rem;
  }
`

export const Button = styled.button`
  font-family: Inter, sans-serif;
  line-height: 1rem;
  font-size: 0.8rem;
  text-transform: uppercase;
  font-weight: 600;
  color: #344054;
  letter-spacing: 0.02rem;
  padding: 0.4rem 0.5rem 0.39rem 0.9rem;
  border: none !important;
  border-radius: 0.5rem;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: box-shadow 0.3s ease;

  &:hover {
    background-color: rgba(225, 218, 218, 0.03);
    color: #4d5a71;
  }

  &.open {
    box-shadow: none !important;
  }

  &.active {
    background-color: ${`${theme.colors.second}40`};

    &:hover {
      background-color: ${`${theme.colors.second}40`};
      color: #344054;
    }
  }
`

export const StyledArrowDownLineIcon = styled(ArrowDownLineIcon)`
  font-size: 1.2rem;
  position: relative;
  top: 0rem;
  height: 1rem;
`

export const StyledArrowUpLineIcon = styled(ArrowUpLineIcon)`
  font-size: 1.2rem;
  position: relative;
  top: -0.05rem;
  height: 1rem;
`
